<template>
  <div class="container">
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-m mb-24">{{ getSectionTitle() }}</h2>

    <div class="category-tabs mb-48">
      <T1GTabs tabLabelType="h3">
        <T1GTabsContent key="0" :title="getTitle(0)" renderContent>
          <T1OffersCategoryGroup :nntab="getTitle(0)" />
        </T1GTabsContent>
        <T1GTabsContent key="1" :title="getTitle(1)">
          <T1OffersCategoryGroup :nntab="getTitle(1)" />
        </T1GTabsContent>
        <T1GTabsContent key="2" :title="getTitle(2)">
          <T1OffersCategoryGroup :nntab="getTitle(2)" />
        </T1GTabsContent>
        <T1GTabsContent key="3" :title="getTitle(3)">
          <T1OffersCategoryGroup :nntab="getTitle(3)" />
        </T1GTabsContent>
      </T1GTabs>
    </div>
  </div>
</template>

<script>
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1GTabs from "./T1Tabs/T1GTabs";
import T1GTabsContent from "./T1Tabs/T1GTabsContent";
import T1OffersCategoryGroup from "./T1OffersCategoryGroup";

export default {
  name: "offers-category-content",
  components: {
    T1Breadcrumbs,
    T1GTabs,
    T1GTabsContent,
    T1OffersCategoryGroup,
  },
  data: () => ({
    titles: ["Najpopularniejsze", "Zwiedzamy Europę", "Egzotyczne", "Objazdowo-pobytowe" ]
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push(
        { name: "Travelone.pl", link: "https://www.travelone.pl/" },
        { name: "Rodzaje ofert", link: "" }
      );
      return crumbsArr;
    },
    getSectionTitle() {
      return "Wycieczki w jednym miejscu";
    },
    getTitle(i) {
      return this.titles[i];
    },
  },
};
</script>

<style lang="scss" scoped>
.category-tabs {
  ::v-deep.tabs {
    border-bottom: 0;
  }
}
</style>
